import Button from '@zenbusiness/zui/Button';
import Card from '@zenbusiness/zui/Card';
import { styled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const BannerContainer = styled(Card)(() => ({
  padding: '1rem',
  marginTop: '1.5rem',
  marginBottom: 0,
}));

export const BannerTitle = styled(Text)(() => ({
  marginBottom: '0.5rem',
}));

export const BannerDescription = styled(Text)(() => ({
  lineHeight: 1.5,
}));

export const StyledButton = styled(Button)(() => ({
  marginTop: '1rem',
}));

BannerContainer.defaultProps = {
  color: 'black',
};

BannerTitle.defaultProps = {
  component: 'p',
  size: 'md',
  weight: 'medium',
  color: 'white',
};

BannerDescription.defaultProps = {
  component: 'p',
  size: 'xs',
  color: 'white',
};

StyledButton.defaultProps = {
  size: 'sm',
  color: 'secondary',
  fullWidth: true,
};
